// Weight-unit helpers. Storage is ALWAYS lb. Display + input flips based on user preference.
const KG_PER_LB = 0.45359237;
const LB_PER_KG = 1 / KG_PER_LB; // 2.20462…

/** "lb" | "kg" — unit the user has selected for input/display. */
export function getUnit(user) {
  return (user?.weight_unit === "kg") ? "kg" : "lb";
}

/** Convert an internal lb value into the user's preferred unit, rounded for display. */
export function lbToDisplay(weightLb, unit) {
  if (weightLb == null || weightLb === "") return null;
  const n = Number(weightLb);
  if (Number.isNaN(n)) return null;
  if (unit === "kg") {
    const kg = n * KG_PER_LB;
    // 1 decimal for kg, drop trailing .0
    return Math.round(kg * 10) / 10;
  }
  // lb: keep up to 1 decimal but drop .0
  return Math.round(n * 10) / 10;
}

/** Parse a user-entered string in their unit and return the canonical lb value (Number) or null. */
export function inputToLb(value, unit) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  if (unit === "kg") return Math.round(n * LB_PER_KG * 100) / 100; // store with 2-decimal precision
  return Math.round(n * 100) / 100;
}

/** Render a weight as a string with the unit suffix, e.g. "185 lb" or "84 kg". */
export function formatWeight(weightLb, unit) {
  const v = lbToDisplay(weightLb, unit);
  if (v == null) return "";
  // Drop ".0" if no decimal portion
  const txt = (Math.round(v * 10) % 10 === 0) ? String(Math.round(v)) : String(v);
  return `${txt} ${unit}`;
}

/** Convenience: input field placeholder "lb" or "kg" */
export function unitSuffix(unit) {
  return unit === "kg" ? "kg" : "lb";
}
